import { Add } from "@mui/icons-material";

const ModuleHeader = ({ onCreateModule }) => {
    return (
        <div className="modules-header">
            <div>
                <h1 className="modules-title">Modules</h1>
                <p className="modules-subtitle">Manage modules and checklists</p>
            </div>
            <button
                onClick={onCreateModule}
                className="modules-create-btn df aic jcc cp"
            >
                <Add style={{ fontSize: '18px', marginRight: '8px' }} />
                Create Module
            </button>
        </div>
    );
};

export default ModuleHeader;

